import PropTypes from 'prop-types';
import RailPanel from 'components/transaction/components/panels/transaction/transactionSideBar/railPanel/RailPanel';
import styles from './ProtocolPanelFrame.module.css';

// Protocol panel frame (Figma `16780:55141`): the rail's panel header ("Protocol" + X), then the body. Shared
// by the panel, its loading fallback and its error state, so all three look the same.
function ProtocolPanelFrame({ onClose, children }) {
    return (
        <RailPanel title="Protocol" closeLabel="Close protocol" onClose={onClose}>
            <div className={styles['protocol-panel__body']}>{children}</div>
        </RailPanel>
    );
}

ProtocolPanelFrame.propTypes = {
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node,
};

export default ProtocolPanelFrame;
